'use client';
import React from 'react';

const internalTeam = [
  { role: 'Gestor de marketing', cost: 'R$ 8.000' },
  { role: 'Designer', cost: 'R$ 5.000' },
  { role: 'Gestor de tráfego', cost: 'R$ 7.000' },
  { role: 'Copywriter', cost: 'R$ 4.500' },
  { role: 'Desenvolvedor', cost: 'R$ 6.000' },
  { role: 'Produção audiovisual', cost: 'R$ 8.000' },
];

const hanzolBenefits = [
  'Estratégia antes da execução',
  'Equipe completa sem precisar montar estrutura interna',
  'Execução integrada (conteúdo, tráfego e campanhas)',
  'Ajustes contínuos com base em dados',
  'Menor esforço operacional para gerir o marketing',
];

function Feat() {
  return (
    <section className="feat section-padding">
      <div className="container ontop">
        <div className="sec-head mb-60 text-center wow fadeInUp">
          <h6 className="sub-title main-color mb-15">Comparativo</h6>
          <h3
            className="feat-headline mb-20"
            style={{ fontSize: 'clamp(1.6rem, 3.5vw, 2.4rem)', lineHeight: 1.2 }}
          >
            Quanto custa montar um time de marketing dentro da sua operação?
          </h3>
          <p
            className="feat-subheadline"
            style={{
              fontSize: 'clamp(0.95rem, 2vw, 1.1rem)',
              maxWidth: '720px',
              margin: '0 auto',
              opacity: 0.85,
            }}
          >
            Antes de internalizar, veja o custo real de manter uma equipe
            completa funcionando.
          </p>
        </div>

        <div className="row lg-marg align-items-stretch">
          <div className="col-lg-6 md-mb50 wow fadeInLeft" data-wow-delay="0.15s">
            <div
              className="feat-card"
              style={{
                border: '1px solid rgba(255,255,255,0.08)',
                borderRadius: '20px',
                padding: '40px',
                height: '100%',
                background: 'rgba(255,255,255,0.02)',
              }}
            >
              <div className="d-flex align-items-center mb-30">
                <i
                  className="fas fa-building"
                  style={{
                    fontSize: '1.6rem',
                    marginRight: '15px',
                    opacity: 0.6,
                  }}
                ></i>
                <h5 style={{ margin: 0 }}>Equipe interna</h5>
              </div>
              <p
                className="sub-title mb-20"
                style={{ opacity: 0.6, fontSize: '0.85rem' }}
              >
                Custo mensal estimado:
              </p>

              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {internalTeam.map((item, i) => (
                  <li
                    key={i}
                    className="d-flex justify-content-between align-items-center"
                    style={{
                      padding: '14px 0',
                      borderBottom: '1px solid rgba(255,255,255,0.06)',
                    }}
                  >
                    <span style={{ fontSize: '1rem' }}>{item.role}</span>
                    <span
                      style={{
                        fontWeight: 600,
                        fontSize: '1rem',
                        opacity: 0.85,
                      }}
                    >
                      {item.cost}
                    </span>
                  </li>
                ))}
              </ul>

              <div
                className="total-row d-flex justify-content-between align-items-center mt-30"
                style={{
                  padding: '20px 24px',
                  background: 'rgba(255,255,255,0.04)',
                  borderRadius: '12px',
                }}
              >
                <span style={{ fontSize: '1.05rem', fontWeight: 500 }}>
                  Total aproximado
                </span>
                <span
                  style={{
                    fontSize: '1.6rem',
                    fontWeight: 700,
                  }}
                >
                  R$ 38.500<span style={{ fontSize: '0.9rem', opacity: 0.6 }}>/mês</span>
                </span>
              </div>

              <p
                style={{
                  marginTop: '25px',
                  fontSize: '0.95rem',
                  opacity: 0.7,
                  lineHeight: 1.6,
                }}
              >
                Além do custo direto, existe gestão de equipe, contratação,
                treinamento e alinhamento constante. Isso impacta tempo,
                operação e consistência do marketing.
              </p>
            </div>
          </div>

          <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.3s">
            <div
              className="feat-card"
              style={{
                border: '1px solid #F5C518',
                borderRadius: '20px',
                padding: '40px',
                height: '100%',
                background:
                  'linear-gradient(180deg, rgba(245,197,24,0.08) 0%, rgba(245,197,24,0.02) 100%)',
                position: 'relative',
              }}
            >
              <div className="d-flex align-items-center mb-30">
                <img
                  src="/assets/imgs/isotipo-light.png"
                  alt=""
                  className="floaty"
                  style={{ width: '32px', marginRight: '15px' }}
                />
                <h5 style={{ margin: 0 }} className="main-color">
                  Com a Hanzol
                </h5>
              </div>
              <p
                className="mb-30"
                style={{ fontSize: '1.05rem', lineHeight: 1.6 }}
              >
                Você acessa uma estrutura pronta para operar, sem o peso
                operacional de uma equipe interna.
              </p>

              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {hanzolBenefits.map((benefit, i) => (
                  <li
                    key={i}
                    style={{
                      padding: '14px 0',
                      borderBottom: '1px solid rgba(245,197,24,0.12)',
                      display: 'flex',
                      alignItems: 'flex-start',
                      fontSize: '1rem',
                    }}
                  >
                    <i
                      className="fas fa-check main-color"
                      style={{ marginRight: '14px', marginTop: '5px' }}
                    ></i>
                    <span>{benefit}</span>
                  </li>
                ))}
              </ul>

              <div
                style={{
                  marginTop: '30px',
                  padding: '20px 24px',
                  background: 'rgba(245,197,24,0.1)',
                  borderRadius: '12px',
                  textAlign: 'center',
                  fontSize: '1.05rem',
                  fontWeight: 500,
                }}
              >
                Estrutura pronta para operar — sem o custo de montar do zero.
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-60 wow fadeInUp">
          <a
            href="https://wa.me/553198550500"
            target="_blank"
            rel="noreferrer"
            className="butn butn-md butn-bg main-colorbg radius-5"
            style={{ color: '#000' }}
          >
            <span className="text" style={{ color: '#000' }}>
              Quero estruturar meu marketing com a Hanzol
            </span>
          </a>
        </div>
      </div>
      <div className="circle-blur">
        <img src="/assets/imgs/patterns/blur1.png" alt="" />
      </div>
    </section>
  );
}

export default Feat;
